class InvoicesAlerts {
    constructor(alertActive, timeFrom, timeTo, sms, email, push) {
        this.alertActive = alertActive;
        this.timeFrom = timeFrom;
        this.timeTo = timeTo;
        this.sms = sms;
        this.email = email;
        this.push = push;
    }
}

export default InvoicesAlerts;